import script from "./Progress.vue?vue&type=script&setup=true&lang=js"
export * from "./Progress.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__